import React, { Fragment } from "react";
import Header from "../../components/header3/Header3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import ContactSection from "../../components/ContactSection";
import SEO from "../../components/seo/SEO";

const ContactPage = (props) => {
  return (
    <Fragment>
      <SEO
        title="Tax & Bookkeeping – CA Firm, Delhi NCR | Binod Verma & Co."
        description="Expert CA firm in Delhi NCR for taxation, GST, audits, societies, NGOs & financial services. 15+ years trusted experience."
        keywords="Startup CA Delhi NCR, NGO CA Firm Delhi, GST Consultant Delhi, Tax Consultant Noida, Audit Firm Gurgaon, Compliance Services Delhi NCR, Return Filing Delhi"
        canonical="https://www.binodverma.com/"
        ogImage="https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg"
        schemaMarkup={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "AccountingService",
              name: "Binod Verma & Co.",
              image:
                "https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg",
              description:
                "Chartered Accountant in Delhi NCR specializing in taxation, GST, audits, NGOs & accounting services.",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Laxmi Nagar",
                addressLocality: "Delhi",
                addressRegion: "Delhi",
                postalCode: "110092",
                addressCountry: "India",
              },
              areaServed: ["Delhi", "Noida", "Gurgaon"],
              url: "https://www.binodverma.com",
            },
            {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "Which is the best CA firm in Delhi for startups?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Binod Verma & Co. provides tax filing, GST, and audit solutions tailored for Delhi-based startups.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Do you provide NGO audit services in Noida?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, we specialize in NGO and society audits in Noida with compliance-focused services.",
                  },
                },
              ],
            },
          ],
        }}
      />
      <Header />
      <main className="page_content about-page">
        <PageTitle
          pageTitle={"Contact Us"}
          pagesub={"Us"}
          pageTop={"Contact"}
        />
        <ContactSection />
        <CtaSection />
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ContactPage;
